import React from "react";
import Layout from "./Layout";
import Account from "../Account";

const AdminAccount = () => {
  return (
    <Layout heading="Account">
        <Account/>
    </Layout>
);
};

export default AdminAccount;
